import type { ReactElement } from "react";
import type { ExecutionMode, Strategy } from "@/types/strategy";

/** Which strategies the Strategies page lists by how they trade: real orders, synthetic paper fills, or both. */
export type ModeFilterValue = "all" | ExecutionMode;

const CHOICES: { value: ModeFilterValue; label: string }[] = [
  { value: "all", label: "All modes" },
  { value: "LIVE", label: "Live" },
  { value: "PAPER", label: "Paper" },
];

export function matchesMode(strategy: Strategy, mode: ModeFilterValue): boolean {
  return mode === "all" || strategy.execution_mode === mode;
}

export function ModeFilter({
  value,
  onChange,
}: Readonly<{ value: ModeFilterValue; onChange: (next: ModeFilterValue) => void }>): ReactElement {
  return (
    <div className="flex gap-1.5" role="group" aria-label="Filter by mode">
      {CHOICES.map((c) => {
        const cls =
          value === c.value
            ? "pill bg-accent-bg text-accent"
            : "pill border border-line-strong bg-transparent text-ink-secondary hover:bg-surface-2";
        return (
          <button
            key={c.value}
            type="button"
            className={cls}
            aria-pressed={value === c.value}
            onClick={() => {
              onChange(c.value);
            }}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
